import src from "IMAGE";
export default { src, width: 227, height: 227, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAN0lEQVR42pWOMQ4AIAwCW/j/n3WoCUEcJGEp9ELVh3ob4/aQ4xMgFSAUOkWPLQ+VSkwEH/osXFodtgA794xZZgAAAABJRU5ErkJggg=="};
